// Initialize Sentry first
import './sentry';

// Configure FontAwesome before any other imports that might use it
import { config } from '@fortawesome/fontawesome-svg-core';
config.autoAddCss = false;
config.familyDefault = 'classic';
config.styleDefault = 'solid';

import App from './app';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { createPublicRoutes, preloadPublicPage } from './routes';
import { makeStore } from './store';
import { restoreProtectedEmails } from './email-protection';

restoreProtectedEmails(document);

const { store, persistor } = makeStore();
const hasWebsite = !!store.getState().website?.website;
await preloadPublicPage(window.location.pathname, hasWebsite);
const router = createBrowserRouter(
  createPublicRoutes({
    hasWebsite,
    loadBookingPage: async () => {
      const { loadBookingPage } = await import('./booking-page-loader');
      return loadBookingPage(store);
    },
    loadAboutPage: async () => {
      const { loadAboutPage } = await import('./booking-page-loader');
      return loadAboutPage(store);
    },
  }),
  // Direct booking loads already contain the server-loaded catalogue. Keep
  // hydration synchronous; the loader runs on subsequent client navigation.
  {
    hydrationData: {
      loaderData: {
        'booking-catalogue': null,
        'public-home': null,
        'public-about': null,
      },
    },
  },
);

ReactDOM.hydrateRoot(
  document,
  <StrictMode>
    <App
      store={store}
      persistor={persistor}
      isFaqPage={window.location.pathname === '/faq'}
    >
      <RouterProvider router={router} />
    </App>
  </StrictMode>,
);
